import { render, staticRenderFns } from "./ApuracaoTabelaDash.vue?vue&type=template&id=5eb143d2&scoped=true&lang=html&"
import script from "./ApuracaoTabelaDash.vue?vue&type=script&lang=js&"
export * from "./ApuracaoTabelaDash.vue?vue&type=script&lang=js&"
import style0 from "./ApuracaoTabelaDash.vue?vue&type=style&index=0&id=5eb143d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb143d2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/ApuracaoTabelaDash.vue
// module id = 1207
// module chunks = 28